import { render, staticRenderFns } from "./InternalDnsService.vue?vue&type=template&id=79383d82&scoped=true&"
import script from "./InternalDnsService.vue?vue&type=script&lang=js&"
export * from "./InternalDnsService.vue?vue&type=script&lang=js&"
import style0 from "./InternalDnsService.vue?vue&type=style&index=0&id=79383d82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79383d82",
  null
  
)

export default component.exports